module.exports = __webpack_public_path__ + "static/img/maps-man.60c1c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maps-man.png
// module id = zext
// module chunks = 1